module.exports = __webpack_public_path__ + "img/my.2a132028.jpg";